

































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getQrcode, queryCurrent, accept, getLoginCode,loginMobile } from '@/api/user/user';
import QRCode from 'qrcodejs2';

@Component
export default class Login extends Vue {
  private keyword: string = process.env.VUE_APP_KEYWORD;
  private interval: any;
  private qrcodeUrl: string = '';
  // 协议及隐私条款 是否显示
  private protocol: boolean = false;
  // 登录方式 wechat mobile
  private loginType = 'wechat';
  // 计时器,注意需要进行销毁
  private timeCounter:any= null;
  // null 则显示按钮 秒数则显示读秒
  private showtime: any = null;
  private formData: object = {
    mobile: '',
    code:''
  }
  private isNewWechat: boolean = false
  private isNewMobile: boolean = false
  private mounted() {
    this.init();
  }
  private init() {
    this.onQueryUser();
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      this.onQueryUser();
    }, 1800);
  }
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name === 'login') {
      this.init();
    }
  }
  // 切换登录方式
  changeType(type){
    this.loginType = type
    if(type == 'mobile') {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  // 协议 处理同意
  private async onProtocolOk() {
    const res:any = await accept();
    if (res.code == 200) {
      if(this.isNewMobile){
        this.bindWechat()
      }else if(this.isNewWechat){
        this.bindMobile()
      }else{
        const params = this.$route.params;
        if (params.referer) {
          window.location.href = decodeURIComponent(params.referer);
        } else if (this.searchPath !== '' && this.searchPath !== '/login') {
          this.$router.push({ path: this.searchPath });
        } else {
          this.$router.push({ path: '/' });
        }
      }
    }
  }
  // 协议 处理取消
  private onProtocolClose() {
    this.$store.dispatch('logoutUser');
    this.$router.push({ name: 'login' });
  }
  // 获取登录前地址
  get searchPath() {
    return this.$store.state.searchPath;
  }
  private async onQueryUser() {
    try {
      const res:any = await queryCurrent('');
      if (typeof res === 'string') {
        // 获取登陆二维码
        this.qrcodeUrl = getQrcode() + '?token=' + res;
        console.log(this.qrcodeUrl)
        document.getElementById('qrcode').innerHTML = '';
        const qrcode = new QRCode('qrcode', {
          width: 180,
          height: 180,
          text: this.qrcodeUrl, // 二维码地址
          colorDark: '#000',
          colorLight: '#fff',
        });
        qrcode.clear();
        qrcode.makeCode(this.qrcodeUrl);
      } else {
        if (this.interval) {
          clearInterval(this.interval);
        }
        this.$store.commit('setUser', res);
        this.$store.dispatch('getRecentList');
        if(res.is_new_user){
          this.isNewWechat = true
        }
        // 如果没有签署协议 则需要先签署协议
        if (!(res as any).protocol_accept) {
          this.protocol = true;
        } else {
          const query:any = this.$route.query;
          if (query.referer) {
            window.location.href = decodeURIComponent(query.referer);
          } else if (this.searchPath !== '' && this.searchPath !== '/login') {
            this.$router.push({path: this.searchPath});
          } else {
            this.$router.push({path: '/'});
          }
        }
      }
    } catch (err) {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  private destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private countDownText(s) {
    this.showtime = `${s}秒后重新发送`
  }
  // 倒计时 60秒
  private countDown(times) {
    const self = this;
    // 时间间隔 1秒
    const interval = 1000;
    let count = 0;
    self.timeCounter = setTimeout(countDownStart, interval);
    function countDownStart() {
      if (self.timeCounter == null) {
        return false;
      }
      count++
      self.countDownText(times - count + 1);
      if (count > times) {
        clearTimeout(self.timeCounter)
        self.showtime = null;
      } else {
        self.timeCounter = setTimeout(countDownStart, interval)
      }
    }
  }

  private ruleValidate: object = {
    mobile: [
      { required: true, message: '电话号码不能为空', trigger: 'blur' },
      { type:'number', message:'请填写正确的手机号',trigger:'blur', transform(value){
        let myReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if(!myReg.test(value)){
          return false
        }else{
          return Number(value)
        }
  }}
    ],
    code: [{ required: true, message: '验证码为空', trigger: 'blur' }],
  }
  // 获取验证码
  private  getCode() {
    (this.$refs.formValidate as any).validateField('mobile',(valid) => {
      if (valid == '') {
        this.countDown(60);
        getLoginCode({mobile:(this.formData as any).mobile})
      } else {
        this.$Message.error('手机号有误');
      }
    })

  }
  // 登录验证
  private mobileValidate(){
    (this.$refs.formValidate as any).validate((valid) => {
      if (valid) {
        this.mobileLogin()
      } else {
        this.$Message.error('格式有误!');
      }
    })
  }
  // 登录
  private async mobileLogin(){
    let res:any = await loginMobile(this.formData)
    this.$store.commit('setUser', res);
    this.$store.dispatch('getRecentList');

    // 新用户 绑定微信
    if(res.is_new_user){
      this.isNewMobile = true
    }
    // 如果没有签署协议 则需要先签署协议
    if (!(res as any).protocol_accept) {
      this.protocol = true;
    } else {
      const query:any = this.$route.query;
      if (query.referer) {
        window.location.href = decodeURIComponent(query.referer);
      } else if (this.searchPath !== '' && this.searchPath !== '/login') {
        this.$router.push({ path: this.searchPath });
      } else {
        this.$router.push({ path: '/' });
      }
    }

  }
  // 跳转绑定手机号
  private bindMobile() {
    this.$router.push({
      name: 'bind',
      params: { page: 'mobile'},
    });
  }
  // 绑定微信号
  private bindWechat(){
    this.$router.push({
      name: 'bind',
      params: { page: 'wechat'},
    });
  }
}
